import React, { useRef, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { UIColorThemes, UIColorTheme } from 'global'
import { Flex, IFlexProps, Text } from 'components'
import textFit from 'textfit'

interface ITipProps {
  tip: string
  uiColorTheme: UIColorThemes
}

interface IOuterFrameProps extends IFlexProps, UIColorTheme {}

const OuterFrame = styled(Flex)<IOuterFrameProps>`
  height: 70px;
  border-top: 1px solid #fff;
  ${({ uiColorTheme }) =>
    uiColorTheme === 'dark' &&
    css`
      border-top: 1px solid #000;
    `}
`

const TipLabel = styled(Text)`
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  ${({ uiColorTheme }) =>
    uiColorTheme === 'dark' &&
    css`
      color: #000;
    `}
`

const TipText = styled(Text)`
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  ${({ uiColorTheme }) =>
    uiColorTheme === 'dark' &&
    css`
      color: #000;
    `}
`

export const Tip = ({ tip, uiColorTheme }: ITipProps) => {
  const tipRef = useRef<HTMLParagraphElement>(null)
  useEffect(() => {
    if (tipRef.current) {
      textFit(tipRef.current, {
        minFontSize: 8,
        maxFontSize: 15,
      })
    }
  }, [tipRef])
  return (
    <OuterFrame
      paddingTop={2}
      marginTop={2}
      uiColorTheme={uiColorTheme}
      flexDirection='column'
      justifyContent='space-between'
    >
      <TipLabel uiColorTheme={uiColorTheme} caps>
        HOT TIP
      </TipLabel>
      <TipText ref={tipRef} uiColorTheme={uiColorTheme}>
        {tip}
      </TipText>
    </OuterFrame>
  )
}
